import React, { useEffect, useState, useCallback } from 'react';
import { Item, Toolbar } from 'devextreme-react/toolbar';
import Button from 'devextreme-react/button';
import DropDownButton from 'devextreme-react/drop-down-button';
import TabPanel, { Item as TabPanelItem } from 'devextreme-react/tab-panel';
import { AthleteForm, AthleteTabpanel, } from '../../components';
import { withLoadPanel } from '../../utils/withLoadPanel';
import './athlete_edit.scss';
import ScrollView from 'devextreme-react/scroll-view';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import { useNavigate, useParams } from 'react-router-dom';
import { getApiToken } from '../../utils/authUtils.js';
import notify from 'devextreme/ui/notify';
import axios from 'axios';
import { useMsal } from "@azure/msal-react";
import { confirm } from 'devextreme/ui/dialog';
const AthleteFormWithLoadPanel = withLoadPanel(AthleteForm);
export const AthleteDetails = () => {
      const { instance, accounts } = useMsal();
    const [data, setData] = useState();
    const [athleteData, setathleteData] = useState({});
    const [clubData, setclubData] = useState([])
    const [trainingsgroupData, settrainingsgroupData] = useState([])
    const [notes, setNotes] = useState();
    const [messages, setMessages] = useState([]);
    const [activeOpportunities, setActiveOpportunities] = useState();
    const [closedOpportunities, setClosedOpportunities] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [isdsvLoading, setisdsvLoading] = useState(false);
    const AthleteTabpanelWithLoadPanel = withLoadPanel(AthleteTabpanel);
    let { athleteId } = useParams()
    const navigate = useNavigate();

    const onLeftClick = () => {
        navigate(-1);
    };
    useEffect(() => {
        loadData();
    }, []);

    const loadData = useCallback(() => {

        getApiToken(instance, accounts).then(token => {
            const dataSource = createStore({
                key: 'athleteId',
                loadUrl: `${process.env.REACT_APP_serverEndpoint}/Athlete/Athletes`,
                insertUrl: `${process.env.REACT_APP_serverEndpoint}/Athlete/InsertAthlete`,
                updateUrl: `${process.env.REACT_APP_serverEndpoint}/Athlete/UpdateAthlete`,
                deleteUrl: `${process.env.REACT_APP_serverEndpoint}/Athlete/DeleteAthlete`,
                onBeforeSend: (method, ajaxOptions) => {
                    ajaxOptions.headers = {
                        'Authorization': "Bearer " + token
                    };
                },
            });
            const dataSource_club = createStore({
                key: 'clubId',
                loadUrl: `${process.env.REACT_APP_serverEndpoint}/Club/ClubsBasic`,
                onBeforeSend: (method, ajaxOptions) => {
                    ajaxOptions.headers = {
                        'Authorization': "Bearer " + token
                    };
                },
            });
            const dataSource_traininggroup = createStore({
                key: 'traininggroupId',
                loadUrl: `${process.env.REACT_APP_serverEndpoint}/Traininggroup/TraininggroupsBasic`,
                onBeforeSend: (method, ajaxOptions) => {
                    ajaxOptions.headers = {
                        'Authorization': "Bearer " + token
                    };
                },
            });
            const dataSource_results = {
                store: createStore({
                    key: 'resultId',
                    loadUrl: `${process.env.REACT_APP_serverEndpoint}/Result/ResultsView`,
                    insertUrl: `${process.env.REACT_APP_serverEndpoint}/Result/InsertResult`,
                    updateUrl: `${process.env.REACT_APP_serverEndpoint}/Result/UpdateResult`,
                    deleteUrl: `${process.env.REACT_APP_serverEndpoint}/Result/DeleteResult`,
                    onBeforeSend: (method, ajaxOptions) => {
                        ajaxOptions.headers = {
                            'Authorization': "Bearer " + token
                        };
                    },
                }), filter: ['athleteId', '=', athleteId]
            };
        
            Promise.all([
                dataSource.load({ filter: ['athleteId', '=', athleteId] }),
                axios.get(`${process.env.REACT_APP_serverEndpoint}/Athlete/GetPersonalBest?athlete_id=` + athleteId.toString(), {
                    headers: {
                      'Authorization': "Bearer " + token
                    }
                  }),
                axios.get(`${process.env.REACT_APP_serverEndpoint}/Athlete/GetAthleteProfilePicture?athlete_id=` + athleteId.toString(), {
                    headers: {
                      'Authorization': "Bearer " + token
                    },
                    responseType: 'blob'
                  })
                //    dataSource_club.load(),
                //   dataSource_traininggroup.load()

            ]).then(async (values) => { 
                // Profilbild als Blob-URL verarbeiten
                let profilePictureUrl = null;
                if (values[2]?.data) {
                    try {
                        profilePictureUrl = URL.createObjectURL(values[2].data);
                    } catch (error) {
                        console.warn('Fehler beim Laden des Profilbilds:', error);
                    }
                }
                
                setData({ 
                    athlete: values[0][0], 
                    clubs: dataSource_club, 
                    traininggroups: dataSource_traininggroup, 
                    results: values[1]?.data?.result_set?.results,
                    personalbests: values[1]?.data?.result_set?.personalBests, 
                    profilePicture: profilePictureUrl 
                }); 
                setIsLoading(false); 
            }).catch((error) => console.log(error));


        });

    }, []);

    const refresh = useCallback(() => {
        setIsLoading(true);
        loadData();
    }, []);
    const onImportDsvBestTimes = useCallback(() => {
        confirm('Sollen die Bestzeiten wirklich aus dem DSV-Portal abgerufen werden?', 'Bestätigung')
            .then((dialogResult) => {
                if (!dialogResult) {
                    return;
                }
                setisdsvLoading(true);
                getApiToken(instance, accounts).then(token => {
                    fetch(`${process.env.REACT_APP_serverEndpoint}/Athlete/ImportDsvBestTimes?athleteId=${athleteId}`, {
                        method: 'GET',
                        headers: {
                            'Authorization': "Bearer " + token
                        }
                    })
                        .then(response => response.json())
                        .then(data => {
                            if (data.success) {
                                notify({
                                    message: data.userMessage || 'Bestzeiten erfolgreich aus dem DSV-Portal importiert',
                                    position: { at: 'bottom center', my: 'bottom center' }
                                }, 'success');
                                refresh();
                            } else {
                                notify({
                                    message: `Fehler beim Importieren der Bestzeiten: ${data.userMessage || 'Unbekannter Fehler'}`,
                                    position: { at: 'bottom center', my: 'bottom center' }
                                }, 'error');
                            }
                            setisdsvLoading(false);
                        })
                        .catch(error => {
                            setisdsvLoading(false);
                            notify({
                                message: `Fehler beim Importieren der Bestzeiten: ${error.userMessage || 'Unbekannter Fehler'}`,
                                position: { at: 'bottom center', my: 'bottom center' }
                            }, 'error');
                        });
                });
            });
    }, [athleteId, instance, accounts, refresh]);
    const onSave = useCallback((data) => {
        getApiToken(instance, accounts).then(token => {
            const dataSource = createStore({
                key: 'athleteId',
                updateUrl: `${process.env.REACT_APP_serverEndpoint}/Athlete/UpdateAthlete`,
                onBeforeSend: (method, ajaxOptions) => {
                    ajaxOptions.headers = {
                        'Authorization': "Bearer " + token
                    };
                },
            });
            dataSource.update(data.athleteId, data).then(() => {
                notify({
                    message: `Sportler "${data.surname} ${data.lastname}" gespeichert`,
                    position: { at: 'bottom center', my: 'bottom center' }
                },
                    'success'
                );
            }
            );
        })
    }, []);

    return (
        <ScrollView className='view-wrapper-scroll'>
            <div className='view-wrapper view-wrapper-athlete-details'>
                <Toolbar className='toolbar-details theme-dependent'>
                    <Item location='before'>
                        <Button icon='arrowleft' stylingMode='text' onClick={onLeftClick} />
                    </Item>
                    <Item location='before' text={function () {
                        if (!!data) {

                            return data?.athlete?.surname + ' ' + data?.athlete?.lastname
                        } else {
                            return 'Lädt...'
                        }

                    }} />
                    {/* <Item location='after' locateInMenu='auto'>
                        <Button
                            text='Terminate'
                            type='default'
                            stylingMode='contained'
                        />
                    </Item>
                    <Item location='after'>
                        <DropDownButton
                            text='Actions'
                            stylingMode='text'
                            dropDownOptions={{ width: 'auto' }}
                            items={['Assign to Me', 'Archive']}
                        />
                    </Item>
                    <Item location='after' locateInMenu='auto'>
                        <div className='separator' />
                    </Item>
                    <Item
                        location='after'
                        locateInMenu='auto'
                        widget='dxButton'
                        showText='inMenu'
                    >
                        <Button
                            text='Copy'
                            icon='copy'
                            stylingMode='text'
                        />
                    </Item>
                    <Item
                        location='after'
                        locateInMenu='auto'
                        widget='dxButton'
                        showText='inMenu'
                    >
                        <Button
                            text='Refresh'
                            icon='refresh'
                            stylingMode='text'
                            onClick={refresh}
                        />
                    </Item> */}
                </Toolbar>

                <div className='panels'>
                    <div className='left'>
                        <AthleteFormWithLoadPanel
                            loading={isLoading}
                            hasData={!!data}
                            data={data}
                            onSave={onSave}
                        />
                    </div>

                    <div className='right'>
                        <div className='dx-card details-card'>
                            <AthleteTabpanelWithLoadPanel
                                loading={isLoading}
                                hasData={!!data}
                                data={data}
                                athleteId={athleteId}
                                onImportDsvBestTimes={onImportDsvBestTimes}
                                isdsvLoading={isdsvLoading}

                            />
                        </div>
                    </div>
                </div>
            </div>
        </ScrollView>
    );
};

